import { db } from '../firebase';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

export const analyticsService = {
  async logTimerEvent(event) {
    // event = { type: 'session_complete', mode, rounds, estimated, actualElapsed, procrastinated, at }
    try {
      // Save session event to Firestore
      await addDoc(collection(db, 'sessions'), {
        mode: event.mode,
        rounds: event.rounds,
        estimated: event.estimated,
        actualElapsed: event.actualElapsed,
        procrastinated: event.procrastinated,
        at: event.at || new Date(),
        createdAt: serverTimestamp(),
        pauses: event.pauses || [],
        interruptions: event.interruptions || [],
        attachedTodoIds: event.attachedTodoIds || [],
        completedChecklist: event.completedChecklist || [],
      });
      // Optionally update dailyStats/monthlyStats here
      // eslint-disable-next-line no-console
      console.debug('[analytics] session saved', event);
    } catch (err) {
      console.error('[analytics] failed to save session', err);
    }
  },
};
